/**
 * Keep the skip link first
 *
 * Accessibility-toolbar plugins inject their markup at the very top of
 * <body> (via JS prepend or output buffering), pushing the skip link down
 * so the toolbar is reached first by the keyboard. A focusable link must
 * live in the body, so DOM position is the only lever — re-assert the skip
 * link as the first child of <body> so it stays first in the tab order.
 */
export default function SkipLink() {
	const skipLink = document.querySelector('.c-skip-link')
	if (!skipLink) return

	const moveToTop = () => {
		if (document.body.firstElementChild !== skipLink) {
			document.body.insertBefore(skipLink, document.body.firstElementChild)
		}
	}

	moveToTop()

	// Catch markup injected after this runs (plugins that prepend on load),
	// then stop watching so there's no ongoing overhead.
	const observer = new MutationObserver(moveToTop)
	observer.observe(document.body, { childList: true })
	setTimeout(() => observer.disconnect(), 3000)
}
